module.exports = {
  title: 'List your activity on FishFriender',
  subtitle: 'You are a fishing profesionnal, guide, lodge, instructor, school, organization, retailer, ... ?',
  intro:
    'FishFriender lets you communicate on your business with the community. Improve your visibility and get free referencing. Users will be able to locate and contact you more easily.',
  warning:
    'The search feature is not active yet for users. If you want to be in the first listed, please fill in the following form.',
  continue: {
    intro:
      'You can modify your entry below. If you want to, you can come back later to this page to modify your activity information using the following link :',
    warning:
      'Just a few steps before your activity is referenced ! In case you need help, just hit the help button on the bottom right of this page. Once done, dont forget to submit your activity !',
    warningDone:
      'Your business is currently being submitted. You will get informed by email of the progress. The platform for end users is expected to be live in the following weeks, we will keep you posted.',
  },
  startSubmissionButton: 'Submit my business',
  form: {
    savedSnackbar: 'Saved',
    missingData: 'The form is incomplete.',
    serverError:
      'An unknown error has occured. Please try again, if the problem persists, please use the help button on the bottom-right of this window, or by email at <b>contact@fishfriender.com</b> . Please include the following technical message :',
    actions: {
      next: 'next >',
      previous: '< previous',
      save: 'Save',
      submit: 'Submit my business',
    },
    confirmModal: {
      missingTitle: 'Some data are missing',
      missingContent:
        'Please fill in all the mandatory steps before submitting.<br/><br/>In case of troubles, please contact us using the hep button on the bottom right of the page or by email at <a href="mailto:contact@fishfriender.com" target="_blank">contact@fishfriender.com</a>',
      intro:
        "By submitting your activity, it will be sent to our verification team. Once you submit it, you won't be able to modify any details of your business until it is published. When it is actually published, you will be granted an access to an administration platform allowing you to modify those information.",
    },
    titles: {
      basic: 'Datas about you',
      administrative: 'Datas about your business',
      agreement: 'Agreement',
      position: 'Your business location',
      pictures: 'Pictures',
      countriesLanguages: 'Countries and languages',
      fishingType: 'Your angling',
      globalPresentation: 'Description',
      licenses: 'Licenses and various accreditations',
      confirmModal: 'Submit my business',
    },
    subtitles: {
      basic: 'In case FishFriender team needs to reach you',
      administrative: "Enter your business' detail",
      agreement:
        'Proof document for your business existence (used only on our side to check, not exposed to the public)',
      position: 'Where can the users find you ?',
      pictures: 'Illustrate your page using 1 to 4 pictures',
      countriesLanguages: 'Which countries do you target ? Which languages do you speak ?',
      fishingType: 'What, how do you fish or sell / teach ?',
      globalPresentation: 'What are your opening hours ? Could you describe yourself in a few words ?',
      licenses:
        'If you have any licenses, accreditations, diploma, qualifications, you can add here the proof documents',
    },
    contact: {
      intro:
        'Please fill in the following form to indicate who you are: those data will only be used to contact you regarding your business. <br/><br/><i>All fields are required.</i>',
      email: {
        label: 'Your email',
        tooltip:
          'This should be your email, not the one of your business. It will be used to contact you if we have any question on your business. To validate your submission, you will have to confirm that this email address is yours.',
        help: 'Example: myemail@example.com',
      },
      firstName: {
        label: 'Your firstname',
      },
      lastName: {
        label: 'Your lastname',
      },
      position: {
        label: 'Position in the business',
        tooltip: 'This is your position: owner, director, saler, marketing director, etc...',
      },
    },
    activity: {
      intro:
        'Please specify your business details below. <br/><br/><i>Fields marked with an asterisk are required.</i>',
      name: {
        label: 'Business name',
        tooltip: 'The name of your activity as it will be displayed on the search results',
      },
      type: {
        label: 'Type',
        selectTitle: 'Select',
        other: 'Other (precise)',
      },
      website: {
        label: 'Website url',
        tooltip:
          'The website of your activity. Users will be redirected to this url. \nPlease specify the complete url, including <b>http</b> or <b>https</b>.',
        help: 'Example: http://www.example.com',
      },
      email: {
        label: 'Contact Email',
        tooltip: 'Email used by users to contact you',
        help: 'Example: monemail@example.com',
      },
      phone: {
        label: 'Phone',
        tooltip: 'The phone number users could use to contact you, if you have any. Please include the country code.',
      },
      proofDocument: {
        label: 'Accreditation',
        tooltip:
          'Document proving that this business is legit : certificate of incorporation, certificate of insurances, etc... <br/>Format : png, jpg or pdf<br/><br/>FishFriender undertakes to keep this document confidential and to use it only in order to verify your business is legit.',
        tooLarge: 'The file size cannot exceed 5mo.',
      },
    },
    agreement: {
      intro:
        'Document proving that this business is legit : certificate of incorporation, certificate of insurances, etc... <br/>Format : png, jpg or pdf<br/><br/>FishFriender undertakes to keep this document confidential and to use it only in order to verify your business is legit.',
      fileSubmitted: 'You already submitted a <b>%(extension)s</b> file %(date)s',
      fileNotSubmitted: 'No file has been submitted yet',
      selectedFile: 'Selected file for upload: <br/> <b>%(filename)s</b>',
      uploadDescription: 'Click or drop a file here to upload it',
      uploadReplaceDescription: 'Click or drop a file here to replace the existing one',
    },
    location: {
      intro:
        'Tell us where users can find your business. For excursions or guides, please provide the starting location, for fixed businesses like lodges or stores, provide the location of your entrance.',
      clickMapTitle: 'Search a place or click on the map to indicate where is your business located',
      searchPlaceholder: 'Search for a place',
      markerPosition: 'Marker is at: ',
      address: {
        intro: 'Fill in the address that user could use to find you :',
      },
      addressStreetNumber: {
        label: 'Street number',
      },
      addressStreet: {
        label: 'Street',
      },
      addressPostalCode: {
        label: 'Postal code',
      },
      addressCity: {
        label: 'City',
      },
      addressAdministrativeAreaLevel1: {
        label: 'Region',
      },
      addressCountry: {
        label: 'Country',
      },
    },
    images: {
      intro:
        'Select <b>1 to 4</b> pictures corresponding to your business. Pictures should be appropriate, in good quality and related to your business. You must own the rights to publish them on the internet.',
      filesSubmitted: 'Alredy uploaded files: ',
      filesSelected: 'Selected files: ',
      uploadDescription: 'Click or drop pictures here.',
    },
    additional: {
      intro:
        "Fill in the informations regarding your fishing profile. Thoses data will be used in search and listing.<br/><br/><i>All those fields are optionnal, but the more you're precise, the more likely users will find you.",
      catchMethods: {
        label: 'Fishing techniques used / taught / sold',
        selectHeader: '+ Add',
        tooltip: 'Select your activities main fishing techniques: the one you primary sell or use.',
        other: 'Other',
        addOther: '+ add',
      },
      targetedFish: {
        label: 'Targeted Fish: ',
        fresh: 'Freshwater',
        salt: 'Saltwater',
      },
      countries: {
        label: 'Targeted countries',
        tooltip:
          "Indicate in which region or country you are present. If you're a brand, tell us where your gear is available, if you're a guide, choose the countries you go with your clients, etc...",
        selectHeader: '+ Add',
        continentOptions: {
          NORTH_AMERICA: 'All North America',
          SOUTH_AMERICA: 'All South America',
          AFRICA: 'All Africa',
          EUROPE: 'All Europe',
          ASIA: 'All Asia',
          OCEANIA: 'All Oceania',
        },
        continent: {
          NORTH_AMERICA: 'North America',
          SOUTH_AMERICA: 'South America',
          AFRICA: 'Africa',
          EUROPE: 'Europe',
          ASIA: 'Asia',
          OCEANIA: 'Oceania',
        },
        optionsContinents: 'Continents',
        optionsOrCountries: 'Countries',
      },
      languages: {
        label: 'Spoken languages',
        selectHeader: '+ Add',
      },
      description: {
        label: 'Brief description',
        tooltip:
          'Write here a description of your activity, specifying any missing information from the previous form. <br/><br/>Please dont enter any link, phone number or email address in this field.',
      },
      startDate: {
        label: 'Activity creation date',
      },
      workingHours: {
        label: 'Working hours',
      },
      brands: {
        label: 'Brands mostly used or sold',
        placeholder: 'Search a brand',
        floatingLabel: '%(nb)s results',
      },
      accreditationFiles: {
        title: 'Licences and various accreditations',
        intro:
          "If you have any licenses, accreditations, diploma, qualifications, you can add here the proof documents. Those qualifications would be displayed on your activity's page. The files will only be used by FishFriender to verify the qualifications, and won't be let available publicly.<br/><br/>Examples: <i><ul><li>Angling guide licence,</li><li>BillFish fondation,</li><li>IGFA,</li><li>BigGameFishingClub,</li><li>Records</li></ul><br/>You can add up to 5 files, each of max 5mo. Can be images (png or jpg) or pdf.",
        uploadDescription: 'Click or drop files here',
        wrongFileFormat: 'Accepted formats : .png, .jpg, .jpeg, .pdf',
        tooManyFiles: 'You can join up to 5 files',
        maxFileSize: 'Each file can not exceed 5mo',
        filesNotSubmitted: 'No file uploaded yet',
        filesSubmitted:
          'You already uploaded %(numberOfFiles)d files. For safety reasons, and because those files contains sensible information, we do not display them here.',
        deleteSubmittedFiles: 'Delete previously uploaded files',
        confirmDelete: 'Are you sure you wish to delete previsouly uploaded files ?',
        selectedFile: 'Selected file for upload: <b>%(filename)s</b>',
      },
    },
  },
  summary: {
    title: 'Summary',
    intro: 'Please check the exactitude of the submitted data',
    contact: 'Contact',
    activity: 'Activity',
    activityProof: 'Proof document',
    location: 'Location',
    images: 'Pictures',
    additional: {
      title: 'Additional datas',
      countries: 'Targeted countries: ',
      languages: 'Spoken languages: ',
      brands: 'Brands mostly used or sold: ',
      catchMethods: 'Fishing techniques: ',
      targetedFishes: 'Targeted fishes: ',
      startDate: 'Activity creation date: ',
      workingHours: 'Working hours: ',
      description: 'Brief description: ',
      accreditationFiles: 'Accreditation files: ',
    },
    agreedText:
      'By checking this box, you declare having the right to publish data about this activity. You also agree that those data would be published on the FishFriender community.',
    cancelButton: 'Cancel',
    confirmButton: 'Submit',
    confirmButtonOk: 'Ok',
    errorSent:
      'An unknown error has happened. Please try again in a few moment. <br/>If the problem persists, please contact us at <a href="contact@fishfriender.com">contact@fishfriender.com</a> with the data you wanted to submit in attachment.',
    successfullySent:
      "Your application has been sent. You will shortly receive a confirmation email at %(email)s, please click on this email's link to confirm that this address is yours. once your email confirmed, our teams will check your application et come back to you.",
  },
}
